<template>
  <div class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"/>
          <h4 class="modal-title">EDIT CUSTOM FIELD</h4>
        </div>
        <div class="modal-body">
          <div class="col-md-12">
            <div class="row">
              <div class="form-group">
                <label class="control-label">Custom Field Name</label>
                <input type="text" placeholder="" class="form-control" v-model="fieldName">
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="modal-footer">
          <button class="btn green" @click.prevent="confirmed()" data-dismiss="modal">Update Custom Field</button>
          <button class="btn default" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    props: ['index','originalFieldName'],
    data() {
      return {
        fieldName: ''
      }
    },
    methods: {
      confirmed() {
        this.$emit('update-custom-field', this.index, this.fieldName);
        this.fieldName = '';
      }
    },
    watch: {
      originalFieldName() {
        this.fieldName = this.originalFieldName;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// FormBuilderEditCustomField.vue?456353ab